import { useCallback, useState } from 'react';
import api from '../api/axios';
import getArray from '../utils/getArray';

// Manages a cache of counties per state and provides a fetch helper.
export default function useCountyCache(selectedMain) {
  const [cache, setCache] = useState({});

  const fetchCountiesForState = useCallback(async (sIdRaw) => {
    if (!sIdRaw && sIdRaw !== 0) return [];
    const sid = Number(sIdRaw);
    if (Number.isFinite(sid) && cache[sid] && cache[sid].length) return cache[sid];
    try {
      const params = { stateId: sid };
      if (selectedMain) params.maincompanyid = selectedMain;
      const resp = await api.get('/auth/counties', { params });
      const items = getArray(resp?.data ?? []);
      setCache((m) => ({ ...m, [sid]: items }));
      return items;
    } catch (e) {
      setCache((m) => ({ ...m, [sid]: [] }));
      return [];
    }
  }, [cache, selectedMain]);

  const ensureCounties = useCallback(async (keys) => {
    if (!Array.isArray(keys) || !keys.length) return;
    await Promise.allSettled((keys || []).map((k) => fetchCountiesForState(k)));
  }, [fetchCountiesForState]);

  return { cache, fetchCountiesForState, ensureCounties, setCache };
}
